export default __webpack_public_path__ + "static/media/맨몸PT_모바일.2cdff28a.jpg";